// Mirrors the backend's `StorageConfigurationPathValidator`: letters, numbers, underscores and
// hyphens per segment, '/' as a single separator between segments - no leading/trailing slash, no
// consecutive slashes, no other characters.
const ALLOWED_PATH_PATTERN = /^[A-Za-z0-9_-]+(?:\/[A-Za-z0-9_-]+)*$/;

export const STORAGE_PATH_HELP_TEXT = "Letters, numbers, underscores and hyphens only, with '/' to separate segments.";

/**
True for an empty string too - callers decide whether empty is acceptable for the field in question
(e.g. a facet path's "no further nesting" or a deployment results path's container/bucket root).
*/
export const isValidStoragePath = (path: string): boolean => path.length === 0 || ALLOWED_PATH_PATTERN.test(path);
